import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DartsScoreboardBaseComponent } from '../scoreboard-base/darts-scoreboard-base.component';

@Component({
    selector: 'ms-darts-scoreboard-header',
    templateUrl: './darts-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe],
})
export class DartsScoreboardHeaderComponent extends DartsScoreboardBaseComponent {}
